module.exports = __webpack_public_path__ + "img/content_box2.b07750b9.png";